<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-primary">
        <!--        <h5 class="card-title">Report History</h5>-->
        <div class="row">
          <div class="col-sm-2">
            <h4 class="card-title font-weight-bold">Report History</h4>
          </div>
        </div>
        @if (selectedReport !== undefined) {
        <div class="card-subtitle">
          {{ selectedReport.reportName }}
          <!--Filtered GID:s {{profile.selectedGIDs}}-->
          <button
            mat-raised-button
            type="button"
            class="btn btn-info btn-raised font-weight-bold pull-right"
            (click)="reloadReports()"
          >
            Refresh History
          </button>
        </div>
        <br />
        }
      </div>
      <div class="card-body">
        <div
          class="mat-elevation-z8"
          style="border-radius: 25px; overflow: hidden; margin-bottom: 30px"
        >
          <mat-table
            #table
            [dataSource]="dataSource"
            matSort
            aria-label="Elements"
            multiTemplateDataRows
          >
            @for (column of displayedColumns; track column) {
            <ng-container matColumnDef="{{ column }}" class="container">
              <mat-header-cell
                class="header-cell"
                *matHeaderCellDef
                mat-sort-header
              >
                {{ headerMap.get(column) }}
              </mat-header-cell>
              <mat-cell class="cell" *matCellDef="let row">
                {{ row[column] }}
                <!--                [href]="report" [download]="fileName"-->
                <!--                <a *ngIf="column=='Download'" id="downloadLink" >-->
                @if ((column==='Download') && (row['completionDate'] !== '')) {
                <button
                  mat-raised-button
                  class="btn btn-sm btn-outline-primary btn-raised"
                  type="button"
                  (click)="downloadButtonClick(row)"
                >
                  <img
                    [src]="formatImgMap.get(row['reportFormat'])"
                    style="width: 20px"
                  />
                </button>
                }
                <!--                </a>-->
              </mat-cell>
            </ng-container>
            }
            <ng-container matColumnDef="expandedDetail">
              <td
                mat-cell
                *matCellDef="let element"
                [attr.colspan]="displayedColumns.length"
              >
                <div
                  class="example-element-detail"
                  [@detailExpand]="
                    element == expandedElement ? 'expanded' : 'collapsed'
                  "
                >
                  <div class="example-element">
                    <div class="container">
                      <div class="row">
                        <div class="col col-md-3">
                          <span class="font-weight-bold">Completion Date:</span>
                        </div>
                        <div class="col col-md-3">
                          {{ element.completionDate }}
                        </div>
                        <div class="col col-md-3">
                          <span class="font-weight-bold">Completion Time:</span>
                        </div>
                        <div class="col col-md-3">
                          {{ element.completionTime }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-md-3">
                          <span class="font-weight-bold">Error:</span>
                        </div>
                        <div class="col-md bg-danger rounded">
                          {{ element.error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let element; columns: displayedColumns"
              class="example-element-row"
              [class.example-expanded-row]="expandedElement === element"
              (click)="
                expandedElement = expandedElement === element ? null : element
              "
            ></mat-row>
            <tr
              mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              class="example-detail-row"
            ></tr>
          </mat-table>
          @if (dataSource.loading$ | async) {
          <div class="spinner-container">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
          }
          <mat-paginator
            #paginator
            [length]="dataSource.counter$ | async"
            [pageIndex]="0"
            [pageSize]="10"
            [pageSizeOptions]="[10, 20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
